import SearchIcon from 'components/elements/icons/SearchIcon'
import WrappedCloseIcon from 'components/elements/icons/WrappedCloseIcon'
import { CLIENT_SETTINGS } from 'constants/clientSettings'
import DOMAIN from 'constants/domains'
import React, { RefObject, useCallback, useState } from 'react'
import styled from 'styled-components'
import { getDomain , isKsDomain, isSaficDomain } from 'utils/domain'

/**
 * 場所選択マップ、検索エリア
 */

const searchIconColor = isKsDomain() ? 'var(--color-footer)' : isSaficDomain() ? 'var(--color-disabled)' :{
  [DOMAIN.SJ]: 'var(--color-footer)',
}[getDomain()]

const searchTextInputColor = isKsDomain() ? 'var(--color-footer)' : isSaficDomain() ? 'var(--color-border)' :{
  [DOMAIN.SJ]: 'var(--color-footer)',
}[getDomain()]

const SearchArea: React.FC<SearchAreaProps> = (props) => {
  const [searchText, setSearchText] = useState<string>('')

  const onChangeSearchText = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setSearchText(event.target.value)
    },
    []
  )

  const onClickClear = useCallback((): void => {
    setSearchText('')
    props.searchInputRef.current?.focus()
  }, [props.searchInputRef])

  const onClickSearch = useCallback((): void => {
    props.searchInputRef.current?.focus()
    google.maps.event.trigger(props.searchInputRef.current, 'keydown', {
      keyCode: 13,
    })
  }, [props.searchInputRef])

  return (
    <StyledSearchArea>
      <SearchTextInput
        ref={props.searchInputRef}
        type="text"
        placeholder="住所または店舗名で検索"
        value={searchText}
        onChange={onChangeSearchText}
      />
      <IconsWrapper>
        {searchText && (
          <IconItem onClick={onClickClear}>
            <WrappedCloseIcon />
          </IconItem>
        )}
        <IconItem onClick={onClickSearch}>
          <SearchIcon color={searchIconColor} width="24px" height="24px" />
        </IconItem>
      </IconsWrapper>
    </StyledSearchArea>
  )
}

export type SearchAreaProps = {
  searchInputRef: RefObject<HTMLInputElement>
}

const StyledSearchArea = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  background: var(--color-content-background);
  border-top: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
`

const SearchTextInput = styled.input`
  flex: 1;
  width: 100%;
  margin: 8px;
  padding: 16px 12px;
  padding-right: 78px;
  font-size: 16px;
  line-height: 21px;
  background: none;
  border: 1px solid ${searchTextInputColor};
  border-radius: 4px;

  ::placeholder {
    color: ${CLIENT_SETTINGS.colors.text}66;
  }

  :focus {
    outline: none;
  }
`

const IconsWrapper = styled.div`
  position: absolute;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
`

const IconItem = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 8px;
`

export default React.memo<SearchAreaProps>(SearchArea)
